import CONQUER from "../CONQUER";
import RoomInstance from "./RoomInstance/RoomInstance";
import LOG, { log } from "../../UTIL/LOG";
import { ACTIONS } from "../../Models/ENUM";

class Rooms 
{
  private conquer : CONQUER;
  public pool     : any = {};

  public constructor(instance: CONQUER) 
  {
    this.conquer = instance;
  }
 
  /*=============== 
 
    GET (get rooms list)
    {
      // no params needed, avatarID is passed in the back
    }

 
    ================*/

  public async get( vars:any ) : Promise<any> 
  {
    let values : any = await this.conquer.do( ACTIONS.ROOM_GET, vars );

    for ( var n in values ) 
    {
      let room                  = new RoomInstance( this.conquer, values[n] );
      this.pool[ room.graphID ]  = room;
    }

    return Promise.resolve( this.pool );
  }

    /*=============== 
 
    GET (JOIN)
    {
        avatarIDs?:[ avatarID ] // [ yohamiID, JID ] 
    }

    [ avatarID1, avatarID2, etc ]
 
    ================*/

  //give avatarIDs or graphID
  public async getOne( vars:any ) : Promise<any> 
  {
    if ( Array.isArray( vars ))    vars = { memberIDs: vars };
    if ( typeof vars == "string")  vars = { gameKey : vars };

    let value   = await this.conquer.do( ACTIONS.ROOM_GETONE, vars );
    let room    = new RoomInstance( this.conquer, value );

    this.pool[ room.graphID ] = room;

    return Promise.resolve( room );
  }

  public async getRoomEntries( vars: { graphID: string } ) : Promise<any>
  {
    let value   = await this.conquer.do( ACTIONS.ROOM_ENTRIES_GET, vars );

    return Promise.resolve( value );
  }

  /*=============== 


    LEAVE
    

    ================*/

  public async leave( graphID:any ) : Promise<any> 
  {
    delete this.pool[ graphID ];
    return Promise.resolve();
  }

  /*=============== 


    ON MESSAGE
    

    ================*/

  public _onServerMessage( object:any ) 
  {
    for ( let n in object.messages ) 
    {
      let message = object.messages[n];
 
      let room = this.pool[message.graphID];
      if( room ) room._onServerMessage(message);
    }
  }
}

export default Rooms;
